import { arrayWithout } from "./arrayWithout.js"

export const arrayWithoutDuplicate = (array, comparePredicate = (a, b) => a === b) => {
  const duplicatePredicate = (value, index, outputArray) =>
    outputArray.some((existingValue) => comparePredicate(existingValue, value))

  return arrayWithout(array, duplicatePredicate)
}
